import palette from '../palette';

const MuiPickersMonth = {
  styleOverrides: {
    monthButton: {
      '&.Mui-disabled': {
        color: palette.gray.light,
      },
    },
  },
};

export default MuiPickersMonth;
